import CustomButton from 'Components/CustomButton'
import CustomDialog from 'Components/CustomDialog'
import StyledTableRow from 'Components/StyledTableRow'
import type { NotificationEditEvent } from 'Services/SalesManagement/Features/Notification/notificationSlice'
import { dateFormatter, datetimeFormatter } from 'Util/formatters'
import { DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import type { FC } from 'react'
import { t } from 'ttag'

const LogDialog: FC<{
  open: boolean
  handleClose: () => void
  log: NotificationEditEvent[]
}> = ({ open, handleClose, log }) => {
  return (
    <CustomDialog open={open} handleClose={handleClose}>
      <DialogTitle>{t`Notification edit log`}</DialogTitle>
      <DialogContent>
        {log.length > 0 ? (
          <TableContainer>
            <Table aria-labelledby="tableTitle" size="small">
              <TableHead>
                <TableRow>
                  <TableCell>{t`Created`}</TableCell>
                  <TableCell>{t`Editor`}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {log.map(logEntry => (
                  <StyledTableRow hover tabIndex={-1} key={logEntry.id}>
                    <TableCell title={datetimeFormatter(logEntry.created)}>
                      {dateFormatter(new Date(logEntry.created), 'dd.MM.yyyy HH.mm')}
                    </TableCell>
                    <TableCell title={logEntry.editor_email}>
                      <Typography variant="body1">{logEntry.editor_email}</Typography>
                    </TableCell>
                  </StyledTableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          <Typography variant="body1">{t`No edit log entries`}</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={handleClose}>{t`Close`}</CustomButton>
      </DialogActions>
    </CustomDialog>
  )
}

export { LogDialog }
